import { useGetCardQuery } from "../services/api.js";
import { useDispatch } from "../hooks.js";
import { useEffect } from "react";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import useLogout from "./useLogout.js";

export default function useCards() {
    const response = useGetCardQuery({});
    const dispatch = useDispatch();
    const logout = useLogout();

    const { error } = response;

    useEffect(() => {
        if ((error as FetchBaseQueryError)?.status === 401) {
            logout("/login");
        }
    }, [dispatch, error, logout, response]);

    return response;
}
